import React from "react";
import PropTypes from "prop-types";
import { UserTypeCheck } from "features/../../../shared/components/auth";
import { useSelector } from "react-redux";
import { getSheetDataState } from "features/Sheets";
import { UserType } from "features/../../../shared/constants/enums";

const ImpersonatedUserUserTypeCheck = ({ restrictTo, component, children }) => {
  const { impersonatedUser } = useSelector(getSheetDataState);

  // If we are not impersonating, perform a standard UserTypeCheck
  if (impersonatedUser?.userType == null) {
    return (
      <UserTypeCheck restrictTo={restrictTo} component={component}>
        {children}
      </UserTypeCheck>
    );
  }

  // If we are impersonating, check the user type of the impersonated user
  if (impersonatedUser.userType === restrictTo) {
    const Component = component;
    return Component ? <Component /> : children;
  }

  return null;
};

ImpersonatedUserUserTypeCheck.propTypes = {
  restrictTo: PropTypes.string.isRequired,
  component: PropTypes.oneOfType([PropTypes.func, PropTypes.element]),
  children: PropTypes.node,
};

ImpersonatedUserUserTypeCheck.defaultProps = {
  restrictTo: UserType.Internal,
  children: null,
};

export default ImpersonatedUserUserTypeCheck;
